import { cn, formatBRL } from '../lib/utils';

// Barra de uso de budget: used/total com cor por nível de ocupação.
export function BudgetBar({
  used,
  total,
  label,
  className,
}: {
  used: number;
  total: number;
  label?: string;
  className?: string;
}) {
  const pct = total > 0 ? Math.min(100, (used / total) * 100) : 0;
  const over = used > total;
  const color = over ? 'bg-danger' : pct > 85 ? 'bg-warning' : 'bg-success';

  return (
    <div className={className}>
      {label && <div className="mb-1 text-xs font-medium text-slate">{label}</div>}
      <div className="h-2 w-full overflow-hidden rounded-full bg-line">
        <div className={cn('h-full rounded-full transition-all', color)} style={{ width: `${Math.max(pct, over ? 100 : pct)}%` }} />
      </div>
      <div className="mt-1 flex justify-between text-xs">
        <span className={cn('font-medium', over ? 'text-danger' : 'text-ink')}>{formatBRL(used)}</span>
        <span className="text-slate">de {formatBRL(total)}</span>
      </div>
    </div>
  );
}
